var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner-wrapper"},[_c('div',[_c('maintenance-info'),_c('bm-privacy'),_vm._m(0),_c('app-header'),_c('router-view')],1),_c('div',[_vm._m(1),_c('app-footer'),_c('scroll-to-top',{attrs:{"position":_vm.scrollY}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-line"},[_c('span'),_c('span'),_c('span')])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-line"},[_c('span'),_c('span'),_c('span')])
}]

export { render, staticRenderFns }